<script>

export default {
    props: {
        items: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
           map: '',           
           style: [
            {
                "featureType": "administrative",
                "elementType": "geometry",
                "stylers": [
                {
                    "visibility": "off"
                }
                ]
            },
            {
                "featureType": "administrative.land_parcel",
                "elementType": "labels",
                "stylers": [
                {
                    "visibility": "off"
                }
                ]
            },
            {
                "featureType": "landscape",
                "elementType": "geometry.fill",
                "stylers": [
                {
                    "color": "#f4f5f5"
                }
                ]
            },
            {
                "featureType": "poi",
                "stylers": [
                {
                    "visibility": "off"
                }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "labels.text",
                "stylers": [
                {
                    "visibility": "off"
                }
                ]
            },
            {
                "featureType": "road",
                "stylers": [
                {
                    "visibility": "off"
                }
                ]
            },
            {
                "featureType": "road",
                "elementType": "labels.icon",
                "stylers": [
                {
                    "visibility": "off"
                }
                ]
            },
            {
                "featureType": "road.local",
                "elementType": "labels",
                "stylers": [
                {
                    "visibility": "off"
                }
                ]
            },
            {
                "featureType": "transit",
                "stylers": [
                {
                    "visibility": "off"
                }
                ]
            },
            {
                "featureType": "water",
                "elementType": "geometry.fill",
                "stylers": [
                {
                    "color": "#092348"
                }
                ]
            },
            {
                "featureType": "water",
                "elementType": "labels",
                "stylers": [
                {
                    "color": "#f4f5f5"
                }
                ]
            }
            ]
        }
    },
    
    mounted() {
        this.initMap()
    },

    render() {

    },

    methods: {
       initMap() {
           this.map = new google.maps.Map(document.getElementById("map"), {
                styles: this.style
            })
            var bounds = new google.maps.LatLngBounds()
            _.forEach(this.items, (item) => {
                var icon = {
                    url: '/assets/logos/map-marker.png',
                    anchor: new google.maps.Point(80, 49),
                    size: new google.maps.Size(109, 49),
                    labelOrigin: new google.maps.Point(52, 15)
                }                
                if (_.has(item, 'marker_label')) {
                    if (item.marker_label != null) {
                        var label = {
                            text: String(item.marker_label),
                            className: 'text-center font-bold text-black'
                        }
                    }                    
                }                
                const marker = new google.maps.Marker({                    
                    position: new google.maps.LatLng(item.lat, item.lng),
                    icon: icon,
                    label: label,                      
                    map: this.map,                    
                })
                if (_.has(item, 'popup')) {
                    if (item.popup != null) {
                        const infowindow = new google.maps.InfoWindow({
                            content: '<div class="p-2 text-center text-lg">'+item.popup+'</div>',
                        })
                        marker.addListener("click", () => {
                            infowindow.open({
                                anchor: marker,
                                map,
                                shouldFocus: false,
                            })
                        })
                    }                    
                }
                bounds.extend(marker.getPosition())                     
            })
            this.map.fitBounds(bounds)
            google.maps.event.addListenerOnce(this.map, 'bounds_changed', () => {
                if (this.map.getZoom() > 11) {
                    this.map.setZoom(this.map.getZoom() - 2);
                }
            })
       }
    }
}
</script>
